export default __webpack_public_path__ + "static/media/homerFind.577bb62b.svg";